import React, { Component } from 'react'
import { connect } from 'react-redux';
import moment from 'moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import IgniteDataTable from '../../common/datatable';
import { history } from "../../../store";

class StockItIncentivesList extends Component {
  constructor(props){
    super(props);
  }

  render() {
    const columns = [
      {
        prop: 'name',
        title: 'Incentive Name',
        format(data, row) {
          return (
            <div>
              { row.attributes.status === 'in_progress' && (
                <OverlayTrigger
                  placement="left"
                  overlay={(
                    <Tooltip id="tooltip" className="tooltip">stock it incentive creation in progress</Tooltip>
                  )}>
                  <span className="glyphicon glyphicon-refresh icon-margin" aria-hidden="true"></span>
                </OverlayTrigger>
              )}
              {data}
            </div>
          );
        }
      },
      {
        prop:  'start-date',
        title: 'Start Date',
        width: '100',
        format(data, row) {return <b>{moment(data).format('DD/MM/YYYY')}</b>}
      },
      {
        prop:  'end-date',
        title: 'End Date',
        width: '100',
        format(data, row) {return <b>{moment(data).format('DD/MM/YYYY')}</b>}
      },
      {prop: 'total-points', title: 'Total Points'}
    ];

    const actions = [
        {
          label: 'Details',
          permissions: {
            action: 'update',
            subjectClass: 'StockItIncentive'
          },
          callback: (row) => {
            history.push(`/admin/stock_it_incentives/${row.id}`);
        }}
    ];

    return (
      <IgniteDataTable
        data={this.props.incentives}
        dataSize={this.props.pagination.number * this.props.pagination.size}
        hasAttributes={true}
        columns={columns}
        actions={actions}
        pagination={{
          onPageChange: this.props.onPageChange,
          page:         this.props.currentPage,
          sizePerPage:  20,
        }}
        remote
      />
    )
  }
}

export default connect()(StockItIncentivesList);



// WEBPACK FOOTER //
// ./src/components/admin/stock-it-incentives/stock-it-incentives-list.jsx